import { CALCULATOR_SCENARIO_VARIANT } from "constants/calculator";

export const getChartData = ({
  t,
  conclusionsPro,
  activePosition,
}: {
  t: any;
  conclusionsPro: any;
  activePosition: 10 | 20 | 30;
}) => {
  const { cashFlowConclusions, userScenarioResult } = conclusionsPro || {};

  const slicePosition =
    activePosition === 10 ? activePosition : activePosition;

  if (userScenarioResult === CALCULATOR_SCENARIO_VARIANT.POSITIVE) {
    const positiveChartData = cashFlowConclusions.cashFlowByYearPositive
      .slice(0, slicePosition + 1)
      .map((item: any, index: number) => ({
        x: item.year,
        y: item.value,
        yearIndex: index + 1,
        cashFlowPrimary: item.value,
        cashFlowAlternative:
          cashFlowConclusions.cashFlowByYearNegative[index].value,
        earlySaleProfit:
          cashFlowConclusions.earlySaleProfitByYearPositive[index].value,
        investmentAcc:
          cashFlowConclusions.investmentAccByYearPositive[index].value,
        alternativePrefix: "ohne",
      }));

    const negativeChartData = cashFlowConclusions.cashFlowByYearNegative
      .slice(0, slicePosition + 1)
      .map((item: any, index: number) => ({
        x: item.year,
        y: item.value,
        yearIndex: index + 1,
        cashFlowPrimary:
          cashFlowConclusions.cashFlowByYearPositive[index].value,
        cashFlowAlternative: item.value,
        earlySaleProfit:
          cashFlowConclusions.earlySaleProfitByYearPositive[index].value,
        investmentAcc:
          cashFlowConclusions.investmentAccByYearPositive[index].value,
        alternativePrefix: "ohne",
      }));

    return {
      charts: [
        {
          id: "investorCashFlowAveragePositive",
          data: positiveChartData,
        },
        {
          id: "investorCashFlowAverageNegative",
          data: negativeChartData,
        },
      ],
      colors: ["#469c49", "#131618"],
      legend: [
        {
          color: "#469c49",
          label: t(
            "calculator_pro_page.analytics.cash_flow_chart.legend.current"
          ),
        },
        {
          color: "#131618",
          label: t(
            "calculator_pro_page.analytics.cash_flow_chart.legend.without_support"
          ),
        },
      ],
    };
  }

  if (userScenarioResult === CALCULATOR_SCENARIO_VARIANT.NEUTRAL) {
    const neutralChartData = cashFlowConclusions.cashFlowByYearNeutral
      .slice(0, slicePosition + 1)
      .map((item: any, index: number) => ({
        x: item.year,
        y: item.value,
        yearIndex: index + 1,
        cashFlowPrimary: item.value,
        cashFlowAlternative:
          cashFlowConclusions.cashFlowByYearNegative[index].value,
        earlySaleProfit:
          cashFlowConclusions.earlySaleProfitByYearNeutral[index].value,
        investmentAcc:
          cashFlowConclusions.investmentAccByYearNeutral[index].value,
        alternativePrefix: "ohne",
      }));

    const negativeChartData = cashFlowConclusions.cashFlowByYearNegative
      .slice(0, slicePosition + 1)
      .map((item: any, index: number) => ({
        x: item.year,
        y: item.value,
        yearIndex: index + 1,
        cashFlowPrimary: cashFlowConclusions.cashFlowByYearNeutral[index].value,
        cashFlowAlternative: item.value,
        earlySaleProfit:
          cashFlowConclusions.earlySaleProfitByYearNeutral[index].value,
        investmentAcc:
          cashFlowConclusions.investmentAccByYearNeutral[index].value,
        alternativePrefix: "ohne",
      }));

    return {
      charts: [
        {
          id: "investorCashFlowAverageNeutral",
          data: neutralChartData,
        },
        {
          id: "investorCashFlowAverageNegative",
          data: negativeChartData,
        },
      ],
      colors: ["#ffbe42", "#131618"],
      legend: [
        {
          color: "#ffbe42",
          label: t(
            "calculator_pro_page.analytics.cash_flow_chart.legend.current"
          ),
        },
        {
          color: "#131618",
          label: t(
            "calculator_pro_page.analytics.cash_flow_chart.legend.without_support"
          ),
        },
      ],
    };
  }

  const negativeChartData = cashFlowConclusions.cashFlowByYearNegative
    .slice(0, slicePosition + 1)
    .map((item: any, index: number) => ({
      x: item.year,
      y: item.value,
      yearIndex: index + 1,
      cashFlowPrimary: item.value,
      cashFlowAlternative:
        cashFlowConclusions.cashFlowByYearPositive[index].value,
      earlySaleProfit:
        cashFlowConclusions.earlySaleProfitByYearNegative[index].value,
      investmentAcc:
        cashFlowConclusions.investmentAccByYearNegative[index].value,
      alternativePrefix: "mit",
    }));

  const positiveChartData = cashFlowConclusions.cashFlowByYearPositive
    .slice(0, slicePosition + 1)
    .map((item: any, index: number) => ({
      x: item.year,
      y: item.value,
      yearIndex: index + 1,
      cashFlowPrimary: cashFlowConclusions.cashFlowByYearNegative[index].value,
      cashFlowAlternative: item.value,
      earlySaleProfit:
        cashFlowConclusions.earlySaleProfitByYearNegative[index].value,
      investmentAcc:
        cashFlowConclusions.investmentAccByYearNegative[index].value,
      alternativePrefix: "mit",
    }));

  return {
    charts: [
      {
        id: "investorCashFlowAverageNegative",
        data: negativeChartData,
      },
      {
        id: "investorCashFlowAveragePositive",
        data: positiveChartData,
      },
    ],
    colors: ["#f85608", "#131618"],
    legend: [
      {
        color: "#f85608",
        label: t(
          "calculator_pro_page.analytics.cash_flow_chart.legend.current"
        ),
      },
      {
        color: "#131618",
        label: t(
          "calculator_pro_page.analytics.cash_flow_chart.legend.with_support"
        ),
      },
    ],
  };
};

export const getEvenlySpacedYears = (chartData: any, count: number) => {
  const years = chartData.map((item: any) => item.x);

  if (years.length <= count) return years;

  const result = [];
  const step = (years.length - 1) / (count - 1);

  for (let i = 0; i < count; i++) {
    const index = Math.round(i * step);
    result.push(years[index]);
  }

  return Array.from(new Set(result));
};
